module.exports = __webpack_public_path__ + "img/signal_wifi_statusbar_null_26x24px.b5a84c93.svg";